var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 20,
    fill: "none",
    viewBox: "0 0 18 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 18.718V1.295Q0 .604.365.302.743 0 1.198 0q.417 0 .782.214l15.173 8.761q.43.226.639.466.207.226.208.565 0 .327-.208.566-.21.226-.639.465L1.98 19.787a1.5 1.5 0 0 1-.782.213q-.456 0-.833-.302Q0 19.397 0 18.718"
  })));
};
export default SvgPlay;